import {ControlledToggle} from '@hm/fundamental'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export const CostLeadershipField: React.FC<Props> = ({checked, onChange, disabled}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <ControlledToggle
      name="action-cost-leadership"
      label={t('actionDialog.costLeadership')}
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
      data-cy="action-cost-leadership"
      data-test-id="action-cost-leadership"
    />
  )
}
